import { Pipe, PipeTransform } from '@angular/core';

import { Api } from '../api';

const propertiesContainingText = [
  'displayName',
  'description',
  'version',
  'context'
];
@Pipe({
  name: 'apisFilter'
})
export class ApisFilterPipe implements PipeTransform {

  transform(apisList: Api[], filterValue: string) {
    if (!apisList || !filterValue) {
      return apisList;
    } else {
      let filterValueLower;
      filterValueLower = filterValue.toLowerCase();
      return apisList.filter(api => {
        return this.isMatchText(api, filterValueLower) || this.isMatchSubscribed(api, filterValueLower);
      });
    }
  }

  isMatchText(api, filterValueLower) {
    return propertiesContainingText.some(propertyName => {
      return api[propertyName] && api[propertyName].toLowerCase().includes(filterValueLower);
    });
  }

  isMatchSubscribed(api, filterValueLower) {
    return api.subscriptions && api.subscriptions.count > 0 && 'subscribed'.includes(filterValueLower);
  }
}
